module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-middleware/node_modules/babel-runtime/core-js/promise.js
// module id = 396
// module chunks = 1 2 3